<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadData" />
        
      </div>
      
      <AppFilter 
        ref="pageFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterDataChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="REFUND_PARAM" 
        v-bind:modalShowDelete="false"
        v-bind:modalShowEdit="false"
        v-bind:modalShowAdd="false">
        <TemplateButton slot="modal-footer-after" @click="onApproveRefundClick" type="button" class="btn btn-success">
          Approve Refund
        </TemplateButton>
      </AppModalForm>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppFilter from "@/components/App/AppFilter";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  // {
  //   key: '_customerType',
  //   text: 'Type',
  // },
  {
    key: '_carparkName',
    text: 'Car Park',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/carparkForm?carparkID=${dataItem.carparkID}">${dataItem['_carparkName']}</a>`;
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['licenseStatus'] === 'Pending' || dataItem['_licenseStatus'] === 'Pending Initial Payment' || dataItem['licenseStatus'] === 'Terminated') {
        return helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum);
      }
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${helper.plFormPLNum(dataItem._licenseNum, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: 'id',
    text: 'PV No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      // return `<a href="${helper.WEB_URL}/plTerminationForm?terminationID=${dataItem.id}">${helper.plFormPLTNum(dataItem.applicationNum, dataItem._carparkNum)}</a>`;
      return `<a target="_blank" href="${helper.WEB_URL}/pv2?carparkID=${dataItem.carparkID}&applicationID=${dataItem.applicationID}">${helper.plFormPVNum(dataItem.applicationID, dataItem._carparkNum)}</a>`;
    },
  },
  {
    key: 'date1',
    text: 'PV Date',
    table_custom: helper.tableCustomDate
  },
  {
    key: 'refund',
    text: 'Refund Method',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(Object.prototype.toString.call(dataItem['dataRef']) === "[object String]") {
        dataItem['dataRef'] = JSON.parse(dataItem['dataRef']);
      }
      if(dataItem['dataRef']['refundMethod'] === '0') {
        return 'GIRO'
      } else if(dataItem['dataRef']['refundMethod'] === '1') {
        return 'Cheque'
      } else {
        return ''
      }
    },
  },
  {
    key: 'data2',
    text: 'Payment Amount',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return helper.formatMoney(dataItem['data3'] || dataItem['data2'])
    },
  },
  {
    key: 'status1',
    text: 'Refund Status',
  },
  {
    key: 'data1',
    text: 'Termination Form No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/plTerminationForm?carparkID=${dataItem.carparkID}&applicationID=${dataItem.data1}">${helper.plFormPLTNum(dataItem.data1, dataItem._carparkNum)}</a>`;
    },
  },
];

const REFUND_PARAM = [
  {
    key: 'passcardID',
    text: 'Passcard Number',
    form_html: function() {
      return 'Approve the this termination refund request?'
    },
  },
];

export default {
  name: "PageRefundList",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppTable,
    AppAddButton,
    AppModalForm,
    AppFilter,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Refund Management' },
        { name: 'Termination Refund Request List' },
      ],

      PARAM,
      REFUND_PARAM,

      pageLicense: null,
      pageCustomer: null,
      pageCarpark: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadLicense();
  },
  methods: {
    loadLicense() {
      this.$refs['pageFilter'].setFilterLoading('Loading license data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLicense = response.data;
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFilter'].setFilterLoading('Loading customer data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'customer data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFilter'].setFilterLoading('Loading customer data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadData() {
      let feedbackItem = 'termination application info';
      this.$refs['pageTable'].setTableLoading('Loading ' + feedbackItem);

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.sort((a, b) => b.createDate - a.createDate);
          response.data.forEach(k => {
            k['_license'] = this.pageLicense.find(j => j.id === k.licenseID);
            k['_licenseNum'] = k['_license']['licenseOperatorNum'];
            k['_carparkNum'] = k['_license']['carparkID'];
            k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
            k['_carparkName'] = (k['_carpark'] || {}).name;
            k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
            k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';
          });
          this.$refs['pageTable'].setTableData(response.data);
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      url += '/requestgroup?type1=terminationRefundRequest&sort=createDate&status1=Pending Approval';
      if(carparkID) {
        url += '&carparkID=' + carparkID;
      }
      if(this.$route.path.includes('Pending')) {
        url += '&status1=Pending Approval';
      }
      return url;
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(true, 'Add New City');
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Approve Refund', tableData[tableDataIndex]);
    },
    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },


    onModalAddDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.name);
      this.$http
        .post(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.name);

      this.$http
        .put(
          this.getUrl(),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },

    onApproveRefundClick() {
      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;
      let actualData = formData['applicationDataData'];
      actualData['refundApprove'] = true;

      let feedbackItem = 'parking license termination appplication data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/applicationData/',
          querystring.stringify({application: JSON.stringify(actualData)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          this.updateTerminationApplication(response.data);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    updateTerminationApplication(applicationData) {
      let formData = this.$refs['pageModal'].$refs['modalForm'].formData;

      let actualData = {}
      actualData['applicationData'] = applicationData;

      let feedbackItem = 'parking license termination appplication info';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.API_URL + '/api2/licenseTerminate/' + formData.id,
          querystring.stringify(actualData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully update ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Refund/PageRefundList.vue